import { render } from "./RGPDLink.vue?vue&type=template&id=07597b12&scoped=true"
import script from "./RGPDLink.vue?vue&type=script&lang=ts"
export * from "./RGPDLink.vue?vue&type=script&lang=ts"

import "./RGPDLink.vue?vue&type=style&index=0&id=07597b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07597b12"

export default script